// fire for gtm inject functions

export const forceChatParse = () =>
  window?.setChatElements && window.setChatElements();
